var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResilience(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,3.67L6.59,14.58v21.83L25.5,47.33l18.91-10.92V14.58L25.5,3.67z M39.41,33.53L25.5,41.56l-13.91-8.03V17.47 L25.5,9.44l13.91,8.03V33.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.41,16.96v11.93C18.7,36.44,25.5,38,25.5,38s6.8-1.56,9.09-9.11V16.96c0,0-5.3-1.44-9.09-2.94 C21.7,15.52,16.41,16.96,16.41,16.96z M32.59,18.48v10.11c-1.13,3.45-3.35,5.38-5.09,6.41c0,0-1.53,0.82-2,0.98v-19.8 c0.65,0.24,1.33,0.49,2,0.71C29.42,17.54,31.33,18.11,32.59,18.48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResilience);
export default __webpack_public_path__ + "static/media/resilience.c08ad98f26ca09c68d9742e5168dbf10.svg";
export { ForwardRef as ReactComponent };